<template>
  <div class="page box">
    <div  >
      <van-sticky class="sticky">
<div>
<studentTitleCard  isChange @change="studentChange"/>
</div>
</van-sticky>
       <div style="margin:0 10px;">
        <div class="project_baogao"  @click="onbodyReport()"> 测训报告 <van-icon name="arrow" /></div>
  </div>
         <div class="center"  v-for="(item,i) in yearList" :key="i">
    <div v-if="!!+item.isActive">
      <van-row gutter="10">
      <van-col span="18" class="text_l">
         <div style="display:flex;align-items: center;height:8vh;">
          <div class="center_name">{{item.name}}</div>
          <div>
          <van-tag plain  type="success">{{['','进行中'][+item.isActive]}}</van-tag>
          </div>
        </div>
        <div style="margin:5px 0 10px 0;"> 
          <span style="color: rgba(0, 0, 0, 0.4);margin-right:10px;">体测时间</span>
          {{item.startTime||''}} ~ {{item.endTime||''}}</div>
      </van-col>
       <van-col span="6" class="text_l" style="display:flex;align-items: center;height:8vh;">
             <van-button type="info" style="border-radius: 15px;margin-top:10px;width:95%;"  size="small" @click="onAddAppoint(item)">成绩登记</van-button>
      </van-col>
    </van-row>
    <!-- <div   style="margin-top:20px;">
        <van-grid :column-num="4" class="van_tag">
            <van-grid-item v-for="(itemc,ic) in item.studentProjectList"  :key='ic' >
            <span  v-if="!!+itemc.isHaveScore" class="tag_span_green"> {{itemc.projectName}} </span>
            <span  v-else class="tag_span_grey"> {{itemc.projectName}} </span>
             </van-grid-item>
        </van-grid>
    </div> -->
    </div>

<div v-else>
<!-- 不可用测试学年 -->
    <div class="noActiceCard">
      <!-- <div  class="ifActiveBox" >
        <img src="@/assets/image/错误提示.png" width="100px"  alt="">
      </div> -->
      <van-row gutter="20">
      <van-col span="8" class="text_l">
        <van-image fit="contain" :src="require('@/assets/image/预约体测.png')"/>
      </van-col>
      <van-col span="16" class="text_l">
        <h2>{{item.name}}</h2>
        <div style="margin-bottom:10px;"> {{item.startTime||''}} ~ {{item.endTime||''}}</div>
        <div style="display:flex;justify-content: space-between;">
            <div>
                <van-button type="warning"  size="small" @click="onReport(item)">体测报告 ></van-button>
                <van-button type="warning"  size="small" style="margin-left:10px;" @click="onbodyReport(item)">测训报告 ></van-button>
            </div>
        </div>
      </van-col>
    </van-row>
    </div>
    

</div>

    </div>

    </div>

  </div>

</template>

<script>
import CustomButton from "@/components/CustomButton.vue";
import { getChildInfoList} from "@/api/studentBind.js";
import { checkOrder,getEduYearList} from "@/api/resultReporting.js";
import studentTitleCard from "@/components/studentTitleCard.vue";
 import { setSession ,getSession} from "@/utils/cookie";

import store from '@/store'
export default {
data () {
    return {
        childInfoList:[],
        studentInfo:{},
        active:'0',
        yearList:[],
        studentTitleInfo:{}
    }
},
components: {
  CustomButton ,
  studentTitleCard
},
mounted () {
    this.init()
  
},
methods:{
  studentChange(val){
    console.log('val',val);
    this.studentTitleInfo =val
      this.getEduYearList()
      this.checkOrder()
  },
  onReport(item){
      let data = JSON.stringify({...this.studentTitleInfo,
           termName: item.name,
      termCode:item.code,
      })
        this.$router.push({path:'fitnessReport',query:{data:data}})
  },
  onbodyReport(){
      let data = JSON.stringify({...this.studentTitleInfo,
          //  termName: item.name,
      // termCode:item.code,
      })
        this.$router.push({path:'bodyForging',query:{data:data}})
  },
    onAddAppoint(item){
       let data = {
            snCode:this.studentTitleInfo.snCode,
            schoolCode:this.studentTitleInfo.schoolCode,
            termName: item.name,
            termCode:item.code,
          }
        this.$router.push({path:'reportingList',query:data})
    },
  
    init(){
          getChildInfoList({status:'1'}).then(res=>{
        console.log(res);
        this.childInfoList = res.data.data||[]
        // if (this.childInfoList.length>0) {
        // this.studentTitleInfo =  JSON.parse(getSession('studentTitleCard'))


        //  this.checkOrder()
        //  this.getEduYearList()
        // }
        })
      
    },
    checkOrder(){
        checkOrder({
            snCode:this.studentTitleInfo.snCode,
            schoolCode:this.studentTitleInfo.schoolCode,
          }).then(res=>{
            // 检查是否有准考证
            console.log(res);
            if (!+res.data.body) {
                // 没有准考证
                this.$dialog
                .alert({
                message: '请先申请电子准考证！！',
                showCancelButton: false
                }).then(() => {
                    this.$router.push({path:'admissionTicket'})
                })
        
            }   
            // res.body
          })
    },
    getEduYearList(){
        getEduYearList({
            snCode:this.studentTitleInfo.snCode,
            schoolCode:this.studentTitleInfo.schoolCode,
          }).then(res=>{
            this.yearList = res.data.data
          })
    },
    OnaddFaceIn(){
        if (!this.studentInfo.faceData||this.studentInfo.faceData=='') {
            this.$notify({ type: "danger", message: '请拍摄证件照！' });
            return
        }
        this.$dialog
        .alert({
          message: '是否确认生成准考证?',
          showCancelButton: true
        })
        .then(() => {
            insertIntoFaceData(this.studentInfo).then(Res=>{
            this.$notify({ type: "success", message: '生成成功！' });
            this.$router.back(-1)
            })
        })
        .catch(() => {
          // on cancel
        })
    },
   
}
}
</script>

<style lang="less" scoped>
.box{
    padding: 5px;
}
.text_l{
    text-align: left;
    text-overflow:ellipsis;
    overflow:hidden;
    font-size: 3vw;
    // white-space:nowrap;
    
}
.noActiceCard{
    position: relative;
 .ifActiveBox{
          position: absolute;
          right: 0px;
          top: 10px;
          transform: rotate(45deg);
        }
}
.project_baogao{
  height: 40px;
  line-height: 40px;
  background-color: #fff;
  border-radius: 5px;
    text-align: center;
  font-size: 3.5vw;
  margin: 10px 0;
  color: #3c69e6;
        box-shadow: 2px 2px 3px 3px rgba(226, 225, 225, 0.6);
}
 .center{
        // height: 250px;
        padding:16px;
        position: relative;
        background-color: #fff;
        border-radius:8px;
        // border: 1px solid #ccc;
        margin: 8px;
        box-shadow: 2px 2px 3px 3px rgba(226, 225, 225, 0.6);
        .center_value{
            color: #bbb;
        }
      .center_name{
          font-size: 5vw;
          font-weight: 600;
          margin-right: 8px;
        }
        .van_tag{
            // margin-left: 20px;
            text-align: center;
            .tag_span_green{
                padding: 4px;
                border: 1px solid rgb(61, 224, 61);
                color: #37cf18;
                text-align: center;
                font-size: 13px;
                width: 90%;
                overflow: hidden;
            }
            .tag_span_grey{
                padding: 4px;
                border: 1px solid rgb(141, 135, 135);
                color: #6a6d69;
                text-align: center;
                font-size: 13px;
                width: 90%;
                overflow: hidden;
            }
            /deep/ .van-grid-item__content{
                padding: 5px;
            }
        }

        .center_text{
            text-align: left;
            font-size: 13px;
            margin-bottom: 50px;
            .center_text_title{
                font-size: 25px;
                font-weight: 700;
            }
        }
        .center_footer{
            text-align: left;
            .center_footer_title{
                font-size: 20px;
                font-weight: normal;
            }
            
            .center_footer_left{

            }
            .center_footer_right{
                .center_footer_right_value{
                font-size: 20px;
                height: 50px;
                line-height: 50px;
                border: 1px solid #bbb;
                margin-top: 10px;
                text-align: center;

            }
            }
        }
    }
</style>